import { i18n } from '@/main';
export const rules = (required = false) => {
  return {
    goodType: [
      { required: true, message: i18n.t('message.validator.required'), trigger: 'change' },
    ],
    trackingNumber: [
      { required, message: i18n.t('message.validator.required'), trigger: 'change' },
    ],
    firstName: [
      { required, message: i18n.t('message.validator.required'), trigger: 'change' },
    ],
    lastName: [
      { required, message: i18n.t('message.validator.required'), trigger: 'change' },
    ],
    phoneNumber: [
      { required, message: i18n.t('message.validator.required'), trigger: 'change' },
    ],
  };
};
